"use client";

import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { AboutPageQueryResult } from "@/sanity.types";
import { urlFor } from "@/sanity/lib/image";
import Image from "next/image";
import { useMediaQuery } from "@/app/(site)/_hooks/useMediaQuery";

type JoinUsSlider = {
	images: NonNullable<AboutPageQueryResult>["joinUs"]["imagesSection"];
};

export default function JoinUsSlider({ images }: JoinUsSlider) {
	const isMobile = useMediaQuery("(max-width: 989.98px)");
	const [emblaRef] = useEmblaCarousel(
		{
			loop: false,
			align: "start",
			containScroll: "trimSnaps",
			skipSnaps: false,
			slidesToScroll: 1,
		},
		[Autoplay({ delay: 4000, stopOnInteraction: false })],
	);

	if (!images || images.length === 0) {
		return null;
	}

	if (isMobile) {
		return (
			<div className="embla group relative sm:hidden">
				<div className="embla__viewport overflow-hidden" ref={emblaRef}>
					<div className="embla__container flex px-3.5">
						{images.map((imageItem, index) => (
							<div
								key={imageItem._key || index}
								className="embla__slide mr-1.5 flex-shrink-0"
								style={{
									flex: "0 0 auto",
									width: "auto",
								}}
							>
								{imageItem.image?.asset && (
									<div className="xs2:h-[57.5vw] relative h-[13.75rem] w-auto max-w-[50vw] overflow-hidden rounded-lg">
										<Image
											src={urlFor(imageItem.image).url()}
											alt={imageItem.image.alt || `Slide ${index + 1}`}
											width={176}
											height={220}
											className="h-full w-auto object-cover"
										/>
										<div className="bg-graphite-black/20 absolute inset-0" />
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		);
	}
}
